import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileTourismusSection = () => <IndustryBenefitsI18n translationPrefix="industryTourismus" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileTourismusSection;
